import { render, staticRenderFns } from "./CallFailedToDialForwarderNotification.vue?vue&type=template&id=06a33996&scoped=true&"
import script from "./CallFailedToDialForwarderNotification.vue?vue&type=script&lang=js&"
export * from "./CallFailedToDialForwarderNotification.vue?vue&type=script&lang=js&"
import style0 from "./CallFailedToDialForwarderNotification.vue?vue&type=style&index=0&id=06a33996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a33996",
  null
  
)

export default component.exports